import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    gameId: Number,
    token: String,
    restoreUrl: String,
    clear: Boolean
  }

  connect() {
    if (!this.hasGameIdValue) return

    if (this.clearValue) {
      localStorage.removeItem(this.storageKey)
      return
    }

    if (this.hasTokenValue) {
      localStorage.setItem(this.storageKey, this.tokenValue)
    } else if (this.hasRestoreUrlValue) {
      this.restore(localStorage.getItem(this.storageKey))
    }
  }

  get storageKey() {
    return `golfscore:game:${this.gameIdValue}:rejoin`
  }

  restore(token) {
    if (!token) return

    const form = document.createElement("form")
    form.method = "post"
    form.action = this.restoreUrlValue

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    form.append(this.hiddenInput("authenticity_token", csrfToken))
    form.append(this.hiddenInput("rejoin_token", token))
    document.body.append(form)
    form.submit()
  }

  hiddenInput(name, value) {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = name
    input.value = value || ""
    return input
  }
}
